import * as React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import {Fragment} from "react";

import './IconTooltip.scss' ;

const IconTooltip = ( props ) =>
{
    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        delayHide,
        visible
    } = usePopperTooltip( { placement: props.placement === undefined ? 'top' : props.placement, followCursor: true, /* delayHide: 100000,*/ offset: [0,8] }, { });

    return (
        <Fragment>
            { props.icon !== undefined && <span onClick={props.onClick} ref={setTriggerRef} style={{...props.style, cursor: 'pointer', color: props.color}} className={props.icon} /> }

            {visible && (
                <div
                    ref={setTooltipRef}
                    {...getTooltipProps({ className: 'tooltip-container' })}
                >
                    {props.text}
                    <div {...getArrowProps({ className: 'tooltip-arrow' })} />
                </div>
            )}
        </Fragment>
    );
}

export default IconTooltip ;
